// Meta-token resolver for WORLD COSTA BLANCA.
//
// SOURCE: docs/32-VISUAL-SEMANTIC-META-TOKENS.md — layer inheritance
//   SHOT > ENTITY > STREET > DISTRICT > WORLD.
// METHOD: IMPLEMENT — plain last-write-wins merge across layers.
// WHY: properties/streets/districts inherit world defaults and override only
//   what makes them distinct; one canonical token chain per renderable.

const LAYER_ORDER = ['world', 'district', 'street', 'entity', 'shot'];

/**
 * @param {{world?:Object, district?:Object, street?:Object, entity?:Object, shot?:Object}} layers
 * @returns {Object} flat resolved token map, e.g. { 'ARCH.FAMILY': 'sea-villa', ... }
 */
export function resolveTokens(layers = {}) {
  const out = {};
  for (const name of LAYER_ORDER) {
    const layer = layers[name];
    if (!layer) continue;
    for (const [key, value] of Object.entries(layer)) out[key] = value;
  }
  return out;
}

/** Convenience: resolve for an entity inside the semantic world. */
export function resolveEntityTokens(semanticWorld, entity, extra = {}) {
  const district = semanticWorld.spaces?.find((s) => s.id === entity.spaceId);
  return resolveTokens({
    world: semanticWorld.tokens,
    district: district?.tokens,
    entity: entity.tokens,
    ...extra
  });
}
